import React, { useState, Fragment } from "react";
import { Link } from "react-router-dom";

import PropTypes from "prop-types";

import "./navbar8.css";

const Navbar8 = (props) => {
  const [link5DropdownVisible, setLink5DropdownVisible] = useState(true);
  const [link5AccordionOpen, setLink5AccordionOpen] = useState(true);
  return (
    <header className="navbar8-container">
      <header data-thq="thq-navbar" className="navbar8-navbar-interactive">
        <img
          alt={props.imageAlt}
          src={props.imageSrc}
          className="navbar8-image1"
        />
        <div data-thq="thq-navbar-nav" className="navbar8-desktop-menu">
          <nav className="navbar8-links1">
            <Link to="/" className="navbar8-link11 thq-link thq-body-small">
              {props.link1 ?? (
                <Fragment>
                  <span className="navbar8-text1">Home</span>
                </Fragment>
              )}
            </Link>
            <Link
              to="/services"
              className="navbar8-link21 thq-link thq-body-small"
            >
              {props.link2 ?? (
                <Fragment>
                  <span className="navbar8-text2">Services</span>
                </Fragment>
              )}
            </Link>
            <Link
              to="/contact"
              className="navbar8-link31 thq-link thq-body-small"
            >
              {props.link3 ?? (
                <Fragment>
                  <span className="navbar8-text3">Contact Us</span>
                </Fragment>
              )}
            </Link>
          </nav>
        </div>
        <div data-thq="thq-burger-menu" className="navbar8-burger-menu">
          <svg viewBox="0 0 1024 1024" className="navbar8-icon10">
            <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
          </svg>
        </div>
        <div data-thq="thq-mobile-menu" className="navbar8-mobile-menu">
          <div className="navbar8-nav">
            <div className="navbar8-top">
              <img
                src={props.imageSrc1}
                alt={props.imageAlt1}
                className="navbar8-image2"
              />
              <div data-thq="thq-close-menu" className="navbar8-close-menu">
                <svg viewBox="0 0 1024 1024" className="navbar8-icon12">
                  <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                </svg>
              </div>
            </div>
            <nav className="navbar8-links2">
              <Link to="/" className="navbar8-link12 thq-link thq-body-small">
                {props.link1 ?? (
                  <Fragment>
                    <span className="navbar8-text1">Home</span>
                  </Fragment>
                )}
              </Link>
              <Link
                to="/services"
                className="navbar8-link22 thq-link thq-body-small"
              >
                {props.link2 ?? (
                  <Fragment>
                    <span className="navbar8-text2">Services</span>
                  </Fragment>
                )}
              </Link>
              <Link
                to="/contact"
                className="navbar8-link32 thq-link thq-body-small"
              >
                {props.link3 ?? (
                  <Fragment>
                    <span className="navbar8-text3">Contact Us</span>
                  </Fragment>
                )}
              </Link>
            </nav>
          </div>
        </div>
      </header>
    </header>
  );
};

Navbar8.defaultProps = {
  link1: undefined,
  link2: undefined,
  imageSrc: "/sydrisworx-300w.png",
  link3: undefined,
  imageAlt: "image",
  imageSrc1: "/sydrisworx-300w.png",
  imageAlt1: "image",
};

Navbar8.propTypes = {
  link1: PropTypes.element,
  link2: PropTypes.element,
  imageSrc: PropTypes.string,
  link3: PropTypes.element,
  imageAlt: PropTypes.string,
  imageSrc1: PropTypes.string,
  imageAlt1: PropTypes.string,
};

export default Navbar8;
